import store from '@/store';
import { SdkPopoverModel } from '../models/popover';

export class SdkPopoverApi {
  public static async getAll(): Promise<SdkPopoverModel[]> {
    await store.getters['campaign/readyPromise'];

    return store.getters['campaign/model'].state.popovers.map((popover) => {
      return new SdkPopoverModel(popover);
    });
  }

  public static async makeActive(id: number): Promise<void> {
    await store.getters['campaign/readyPromise'];

    const popover = store.getters['campaign/model'].state.popovers.find((popover) => popover.state.id === id);

    if (!popover) {
      throw Error('Unrecognized popover id. Not found in collection');
    }

    if (
      popover.state.config.settings.state.advanced.visibilityCondition &&
      !popover.state.config.settings.state.advanced.visibilityCondition?.check()
    ) {
      throw new Error('Cannot go to popover that user is not allowed to see (visibility conditions)');
    }

    store.commit('campaign/setPopoverId', id);
  }
}
